export const actions = {
	async create({ rootGetters, dispatch, commit }, { companyId, data }) {
		return await useNuxtApp()
			.$api(`/api/company/${companyId}/tiktok-accounts/`, {
				method: 'POST',
				body: data,
			})
			.then(() => {
				commit('company/clearCacheCompany', null, { root: true })
				dispatch('company/retrieve', { companyId: rootGetters.companyId }, { root: true })
			})
	},

	async delete({ rootGetters, dispatch, commit }, { companyId, accountId }) {
		return await useNuxtApp()
			.$api(`/api/company/${companyId}/tiktok-accounts/${accountId}/`, {
				method: 'DELETE',
			})
			.then(() => {
				commit('company/clearCacheCompany', null, { root: true })
				dispatch('company/retrieve', { companyId: rootGetters.companyId }, { root: true })
			})
	},
}
